import Vue from 'vue'
import Router from 'vue-router'

import mainRouter from './main'

Vue.use(Router)

export default new Router({
  routes: [
    ...mainRouter,
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js